module.exports = __webpack_public_path__ + "static/img/url.1bd1bd6c.png";